<template>
  <div class="principal-cuestionario">
    <TituloSeccion titulo="CUESTIONARIO DE PREANÁLISIS" />
    <div class="container contenedor-cuestionariopreanalisis">
      <!--TEST SECCIONES-->
      <form class="mb-4" @submit.prevent="GuardarCuestionario">
        <keep-alive>
          <div ref="seccion-uno" v-show="seccionActual == 1">
            <form
              class="requiere-validacion"
              novalidate
              ref="formularioUno"
              v-bind:class="{ 'was-validated': formularioValidado1 }"
            >
              <div class="row row-cols-lg-12 w-100 mt-3">
                <strong class="titulo-seccion"
                  >Información de la empresa de la empresa</strong
                >
                <p class="parrafo-instrucciones mt-2">
                  Ingresa la información general de la empresa, incluye el giro,
                  años y lugares donde operan.
                </p>
              </div>
              <div class="row row-cols-lg-12 w-100" style="align-items: center">
                <div class="col-lg-6 col-sm-6">
                  <etiqueta-campo
                    texto="Giro específico de la empresa"
                    :requerido="true"
                  ></etiqueta-campo>
                  <span style="display: flex; align-items: center">
                    <input
                      :disabled="this.soloLectura"
                      maxlength="100"
                      type="text"
                      placeholder="Giro específico de la empresa*"
                      class="form-control campo-basico"
                      v-model="DatosCuestionario.giroEmpresa"
                      required
                    />
                    <div
                      class="invalid-feedback"
                      style="text-align: left; font-family: 'Poppins'"
                    >
                      El giro específico de la empresa es requerido.
                    </div>
                    <span
                      v-tooltip.right="
                        'Incluir el producto (s) o servicio (s) que ofrecen de forma detallada.'
                      "
                    >
                      <i
                        class="fas fa-question-circle icono-ayuda fa-lg"
                        style="padding-left: 20px"
                      ></i>
                    </span>
                  </span>
                </div>
                <div class="col-lg-6 col-sm-6">
                  <etiqueta-campo
                    texto="Años que lleva la empresa operando"
                    :requerido="true"
                  ></etiqueta-campo>
                  <span style="display: flex; align-items: center">
                    <VueAutonumeric
                      :disabled="soloLectura"
                      class="form-control campo-basico"
                      :options="{
                        maximumValue: '100',
                        minimumValue: '0',
                        decimalPlaces: '0',
                      }"
                      :placeholder="'Años de operación de la empresa *'"
                      v-model="DatosCuestionario.aniosOperacion"
                      required
                    ></VueAutonumeric>
                    <div
                      class="invalid-feedback"
                      style="text-align: left; font-family: 'Poppins'"
                    >
                      El tiempo de operación de la empresa es requerido.
                    </div>
                    <span
                      v-tooltip.right="
                        'Si existe experiencia previa con otra empresa o los socios han operado de forma independiente, colocarlo.'
                      "
                    >
                      <i
                        class="fas fa-question-circle icono-ayuda fa-lg"
                        style="padding-left: 20px"
                      ></i>
                    </span>
                  </span>
                </div>
              </div>
              <div class="row row-cols-lg-12 w-100" style="align-items: center">
                <div class="col-lg-12 col-sm-12">
                  <etiqueta-campo
                    texto="Participación geográfica de la empresa"
                  ></etiqueta-campo>
                  <span style="display: flex; align-items: center">
                    <input
                      placeholder="Detallar la participación geográfica de la empresa."
                      :disabled="this.soloLectura"
                      class="form-control campo-basico"
                      rows="3"
                      v-model="DatosCuestionario.participacionGeografica"
                    />
                    <span
                      v-tooltip.right="
                        'Lugares donde operan y/o venden sus productos o servicios Incluir (municipios, ciudades, estados de la república, países, etc.'
                      "
                    >
                      <i
                        class="fas fa-question-circle icono-ayuda fa-lg"
                        style="padding-left: 20px"
                      ></i>
                    </span>
                  </span>
                </div>
                <button
                  ref="submitUno"
                  @click.prevent="ValidaFormSiguiente"
                  class="btn btn-primary"
                  hidden
                  type="submit"
                >
                  Submit form
                </button>
              </div>
            </form>
          </div>
        </keep-alive>
        <keep-alive>
          <div ref="seccion-dos" v-show="seccionActual == 2">
            <div class="row row-cols-lg-12 w-100 mt-3">
              <strong class="titulo-seccion">Principales clientes</strong>
              <p class="parrafo-instrucciones mt-2">
                Ingresa los clientes con los que tu negocio cuenta
                frecuentemente.
              </p>
            </div>
            <div v-for="(cliente, index) in FormClientes" v-bind:key="index">
              <div class="row row-cols-lg-12 w-100">
                <div class="col-lg-6">
                  <etiqueta-campo texto="Nombre del cliente"></etiqueta-campo>
                  <input
                    v-model="cliente.cliente"
                    placeholder="Nombre del cliente *"
                    :disabled="soloLectura"
                    class="form-control campo-basico"
                    rows="3"
                    required
                  />
                </div>
                <div class="col-lg-6">
                  <etiqueta-campo
                    texto="Producto o servicio de compra"
                  ></etiqueta-campo>
                  <input
                    v-model="cliente.producto"
                    placeholder="Producto o servicio de compra *"
                    :disabled="soloLectura"
                    class="form-control campo-basico"
                    rows="3"
                    required
                  />
                </div>
              </div>
              <div class="row row-cols-lg-12 w-100">
                <div class="col-lg-6">
                  <etiqueta-campo
                    texto="Porcentaje sobre ventas totales"
                  ></etiqueta-campo>
                  <VueAutonumeric
                    :disabled="soloLectura"
                    class="form-control campo-basico"
                    :options="{
                      suffixText: '%',
                      maximumValue: '100',
                      minimumValue: '0',
                      decimalPlaces: '2',
                    }"
                    :placeholder="'Porcentaje sobre ventas totales *'"
                    v-model="cliente.porcentajeVenta"
                    required
                  ></VueAutonumeric>
                </div>
                <div class="col-lg-6"></div>
              </div>
              <div
                class="col-lg-12 col-sm-12"
                style="text-align: end"
                v-if="soloLectura == false"
              >
                <strong
                  v-if="FormClientes.length > 1"
                  class="etiqueta-nuevo-documento"
                  @click.prevent="EliminarCliente(cliente)"
                  >Eliminar cliente</strong
                >
              </div>
            </div>
            <div
              class="col-lg-12 col-sm-12 col-agregar-beneficiario"
              style="text-align: end"
            >
              <label
                v-if="this.soloLectura == false"
                class="etiqueta-nuevo-documento"
                @click.prevent="AgregarCliente()"
                >Agregar otro cliente</label
              >
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div ref="seccion-tres" v-show="seccionActual == 3">
            <div class="row row-cols-lg-12 w-100 mt-3">
              <strong class="titulo-seccion">Ventas</strong>
              <p class="parrafo-instrucciones mt-2">
                Ingresa el porcentaje que representa la venta en los siguientes
                rubros:
              </p>
            </div>
            <div class="row row-cols-lg-12 w-100 mt-3">
              <div class="col-lg-6">
                <div class="input-group">
                  <etiqueta-campo
                    texto="Porcentaje de ventas en efectivo"
                  ></etiqueta-campo>
                  <VueAutonumeric
                    :disabled="soloLectura"
                    class="form-control campo-basico"
                    :options="{
                      maximumValue: '100',
                      minimumValue: '0',
                      decimalPlaces: '2',
                    }"
                    :placeholder="'Porcentaje de ventas en efectivo'"
                    v-model="DatosCuestionario.ventasEfectivo"
                  ></VueAutonumeric>
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      style="border-radius: 0px; border: 1px solid"
                      >%</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <etiqueta-campo
                  texto="Porcentaje de ventas a gobierno"
                ></etiqueta-campo>
                <div class="input-group">
                  <VueAutonumeric
                    :disabled="soloLectura"
                    class="form-control campo-basico"
                    :options="{
                      maximumValue: '100',
                      minimumValue: '0',
                      decimalPlaces: '2',
                    }"
                    :placeholder="'Porcentaje de ventas a gobierno'"
                    v-model="DatosCuestionario.gobierno"
                  ></VueAutonumeric>
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      style="border-radius: 0px; border: 1px solid"
                      >%</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-cols-lg-12 w-100 mt-3">
              <div class="col-lg-6">
                <etiqueta-campo
                  texto="Porcentaje de ventas de contado"
                ></etiqueta-campo>
                <div class="input-group">
                  <VueAutonumeric
                    :disabled="soloLectura"
                    class="form-control campo-basico"
                    :options="{
                      maximumValue: '100',
                      minimumValue: '0',
                      decimalPlaces: '2',
                    }"
                    :placeholder="'Porcentaje de ventas de contado'"
                    v-model="DatosCuestionario.ventasContado"
                  ></VueAutonumeric>
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      style="border-radius: 0px; border: 1px solid"
                      >%</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <etiqueta-campo
                  texto="Porcentaje de ventas de intercompañía"
                ></etiqueta-campo>
                <div class="input-group">
                  <VueAutonumeric
                    :disabled="soloLectura"
                    class="form-control campo-basico"
                    :options="{
                      maximumValue: '100',
                      minimumValue: '0',
                      decimalPlaces: '2',
                    }"
                    :placeholder="'Porcentaje de ventas de intercompañias'"
                    v-model="DatosCuestionario.interCompania"
                  ></VueAutonumeric>
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      style="border-radius: 0px; border: 1px solid"
                      >%</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-cols-lg-12 w-100 mt-3">
              <div class="col-lg-6">
                <etiqueta-campo
                  texto="Porcentaje de ventas a crédito"
                ></etiqueta-campo>
                <div class="input-group">
                  <VueAutonumeric
                    :disabled="soloLectura"
                    class="form-control campo-basico"
                    :options="{
                      maximumValue: '100',
                      minimumValue: '0',
                      decimalPlaces: '2',
                    }"
                    :placeholder="'Porcentaje de ventas a crédito'"
                    v-model="DatosCuestionario.ventasCredito"
                    required
                  ></VueAutonumeric>
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      style="border-radius: 0px; border: 1px solid"
                      >%</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <etiqueta-campo
                  texto="Porcentaje de ventas no contabilizadas"
                ></etiqueta-campo>
                <div class="input-group">
                  <VueAutonumeric
                    :disabled="soloLectura"
                    class="form-control campo-basico"
                    :options="{
                      maximumValue: '100',
                      minimumValue: '0',
                      decimalPlaces: '2',
                    }"
                    :placeholder="'Porcentaje de ventas no contabilizadas'"
                    v-model="DatosCuestionario.ventasNoContabilizadas"
                  ></VueAutonumeric>
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      style="border-radius: 0px; border: 1px solid"
                      >%</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row row-cols-lg-12 w-100 mt-3">
              <div class="col-lg-6">
                <etiqueta-campo
                  texto="Porcentaje de ventas de exportación"
                ></etiqueta-campo>
                <div class="input-group">
                  <VueAutonumeric
                    :disabled="soloLectura"
                    class="form-control campo-basico"
                    :options="{
                      maximumValue: '100',
                      minimumValue: '0',
                      decimalPlaces: '2',
                    }"
                    :placeholder="'Porcentaje de ventas de exportación'"
                    v-model="DatosCuestionario.exportacion"
                  ></VueAutonumeric>
                  <div class="input-group-append">
                    <span
                      class="input-group-text"
                      style="border-radius: 0px; border: 1px solid"
                      >%</span
                    >
                  </div>
                </div>
              </div>
              <div class="col-lg-6"></div>
            </div>
          </div>
        </keep-alive>
        <keep-alive>
          <div ref="seccion-cuatro" v-show="seccionActual == 4">
            <div class="row row-cols-lg-12 w-100 mt-3">
              <strong class="titulo-seccion">Recursos</strong>
              <p class="parrafo-instrucciones mt-2">
                Ingresa cual es el monto del financiamiento requerido y cual
                será el destino del mismo
              </p>
            </div>
            <form
              class="requiere-validacion"
              novalidate
              ref="formularioCuatro"
              v-bind:class="{ 'was-validated': formularioValidado4 }"
            >
              <div class="row row-cols-lg-12 w-100">
                <div class="col-lg-6">
                  <etiqueta-campo
                    texto="Monto solicitado"
                    :requerido="true"
                  ></etiqueta-campo>
                  <VueAutonumeric
                    :disabled="this.soloLectura"
                    class="form-control campo-basico"
                    :options="opcionesAutoNumeric"
                    :placeholder="'Monto Solicitado *'"
                    v-model="DatosCuestionario.montoSolicitado"
                    required
                  ></VueAutonumeric>
                  <div
                    class="invalid-feedback"
                    style="text-align: left; font-family: 'Poppins'"
                  >
                    El monto solicitado es requerido.
                  </div>
                </div>
                <div class="col-lg-6 col-sm-6">
                  <etiqueta-campo
                    texto="Uso específico que se le dará al inmueble"
                    :requerido="true"
                  ></etiqueta-campo>
                  <span style="display: flex; align-items: center">
                    <input
                      placeholder="Uso específico que se le dará al inmueble"
                      :disabled="this.soloLectura"
                      class="form-control campo-basico"
                      rows="3"
                      v-model="DatosCuestionario.usoInmueble"
                      required
                    />
                    <div
                      class="invalid-feedback"
                      style="text-align: left; font-family: 'Poppins'"
                    >
                      El uso específico de los recursos es requerido.
                    </div>
                    <span
                      v-tooltip.right="
                        'En caso de rentarlo, ingresar el plazo y monto del contrato de arrendamiento a celebrar.'
                      "
                    >
                      <i
                        class="fas fa-question-circle icono-ayuda fa-lg"
                        style="padding-left: 20px"
                      ></i>
                    </span>
                  </span>
                </div>
              </div>
              <div class="row row-cols-lg-12 w-100">
                <div class="col-lg-12 col-sm-12">
                  <etiqueta-campo
                    texto="Destino especifico de los recursos"
                  ></etiqueta-campo>
                  <span style="display: flex; align-items: center">
                    <input
                      placeholder="Destino especifico de los recursos"
                      :disabled="this.soloLectura"
                      class="form-control campo-basico"
                      rows="3"
                      v-model="DatosCuestionario.destinoRecurso"
                    />
                    <span
                      v-tooltip.right="
                        '¿Qué va a adquirir con el dinero, producto del financiamiento?'
                      "
                    >
                      <i
                        class="fas fa-question-circle icono-ayuda fa-lg"
                        style="padding-left: 20px"
                      ></i>
                    </span>
                  </span>
                </div>
                <button
                  ref="submitCuatro"
                  @click.prevent="ValidaFormSiguiente"
                  class="btn btn-primary"
                  hidden
                  type="submit"
                >
                  Submit form
                </button>
              </div>
            </form>
          </div>
        </keep-alive>
        <keep-alive>
          <div ref="seccion-cinco" v-show="seccionActual == 5">
            <div class="row row-cols-lg-12 w-100 mt-3">
              <strong class="titulo-seccion">Socios</strong>
              <p class="parrafo-instrucciones mt-2">
                Coloca los ingresos adicionales que tengan los socios fuera de
                la empresa.
              </p>
            </div>
            <form
              class="requiere-validacion"
              novalidate
              ref="formularioCinco"
              v-bind:class="{ 'was-validated': formularioValidado5 }"
            >
              <div class="row row-cols-lg-12 w-100" style="align-items: center">
                <div class="col-lg-12 col-sm-12">
                  <etiqueta-campo
                    texto="Ingresos extra del socio o los socios"
                  ></etiqueta-campo>
                  <span style="display: flex; align-items: center">
                    <VueAutonumeric
                      :disabled="this.soloLectura"
                      class="form-control campo-basico"
                      :options="opcionesAutoNumeric"
                      :placeholder="'Ej. $150,000'"
                      v-model="DatosCuestionario.ingresoExtraSocio"
                    ></VueAutonumeric>
                    <span
                      v-tooltip.right="
                        'Ingresos no relacionados con la empresa y que puedan comprobarse documentalmente.'
                      "
                    >
                      <i
                        class="fas fa-question-circle icono-ayuda fa-lg"
                        style="padding-left: 20px"
                      ></i>
                    </span>
                  </span>
                </div>
              </div>
              <div class="row row-cols-lg-12 w-100">
                <div class="col-lg-12">
                  <etiqueta-campo
                    texto="Si ingresaste datos en la respuesta anterior, detallar el origen de los ingresos, así como los montos correspondientes"
                  ></etiqueta-campo>
                  <input
                    placeholder=""
                    :disabled="this.soloLectura"
                    class="form-control campo-basico"
                    rows="3"
                    v-model="DatosCuestionario.detalleIngresoExtraSocio"
                  />
                </div>
              </div>
              <div class="row row-cols-lg-12 w-100">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-8">
                      <label class="texto-checkbox"
                        >Los socios cuentan con saldos vencidos en el Buró de
                        Crédito *</label
                      >
                    </div>
                    <div
                      class="col-4"
                      style="display: flex; justify-content: space-between"
                    >
                      <span
                        class="opcion-checkbox"
                        v-for="opcion in opcionesRadio"
                        v-bind:key="opcion.value"
                      >
                        <input
                          :disabled="soloLectura"
                          type="radio"
                          class="form-check-input"
                          :value="opcion.value"
                          v-model="
                            DatosCuestionario.sociosTienenSaldosVencidosBuro
                          "
                          required
                        />
                        <label class="etiqueta-checkbox">
                          {{ opcion.text }}
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row row-cols-lg-12 w-100">
                <div class="col-lg-12">
                  <div class="row">
                    <div class="col-8">
                      <label class="texto-checkbox"
                        >Los socios cuentan con antecedentes en el Buró de
                        Crédito *</label
                      >
                    </div>
                    <div
                      class="col-4"
                      style="display: flex; justify-content: space-between"
                    >
                      <span
                        class="opcion-checkbox"
                        v-for="opcion in opcionesRadio"
                        v-bind:key="opcion.value"
                      >
                        <input
                          :disabled="soloLectura"
                          type="radio"
                          class="form-check-input"
                          :value="opcion.value"
                          v-model="
                            DatosCuestionario.sociosTienenAntecedentesBuro
                          "
                          required
                        />
                        <label class="etiqueta-checkbox">
                          {{ opcion.text }}
                        </label>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row row-cols-lg-12 w-100">
                <div class="col-lg-12">
                  <etiqueta-campo
                    texto="Si la respuesta es afirmativa detallar el origen del problema, así como los montos correspondientes"
                  ></etiqueta-campo>
                  <input
                    placeholder=""
                    :disabled="this.soloLectura"
                    class="form-control campo-basico"
                    rows="3"
                    v-model="DatosCuestionario.detalleProblemaSocio"
                  />
                </div>
              </div>
              <button
                ref="submitCinco"
                @click.prevent="ValidaFormSiguiente"
                class="btn btn-primary"
                hidden
                type="submit"
              >
                Submit form
              </button>
            </form>
          </div>
        </keep-alive>
        <button
          class="btn btn-success col-md-12"
          type="submit"
          hidden
          ref="enviaCuestionario"
          name="enviaCuestionario"
        >
          Enviar Cuestionario
        </button>
      </form>
      <div
        class="row row-cols-lg-12 mt-5 mb-3 columna-botones"
        style="justify-content: flex-end"
      >
        <button
          type="button"
          class="boton-transparente boton-seccion-anterior"
          @click.prevent="SeccionAnterior()"
          v-if="seccionActual != 1"
        >
          Anterior
        </button>
        <button
          type="button"
          class="boton-primario boton-siguiente-seccion"
          @click.prevent="SeccionSiguiente()"
          v-if="seccionActual != 5"
        >
          Siguiente
        </button>
        <button
          type="button"
          :disabled="this.soloLectura"
          class="boton-primario boton-siguiente-seccion"
          @click.prevent="ActivarEnvioCuestionario"
          v-if="seccionActual == 5"
        >
          Finalizar
        </button>
      </div>
    </div>
  </div>
</template>
<script lang="js">
//Componentes
import axios from "axios";
import TituloSeccion from "../../../Componentes/TituloSeccion.vue";
import mixinSolicitudInscripcion from "../Mixins/MixinSolicitudInscripcion";
import VueAutonumeric from "../../../../../../node_modules/vue-autonumeric/src/components/VueAutonumeric.vue";
//rutasApi
var rutaGuardarCuestionario = "/api/Master/CuestionarioPreAnalisisPersonaMoral/GuardarCuestionarioPreAnalisisPersonaMoral";
var rutaGuardarClienteCuestionario = "/api/Master/CuestionarioPreAnalisisPersonaMoral/GuardarClienteCuestionario";
var rutaObtenerCuestionario = "/api/Master/CuestionarioPreAnalisisPersonaMoral/ObtenerCuestionario";
var rutaObtenerClientes = "/api/Master/CuestionarioPreAnalisisPersonaMoral/ObtenerClientes";
var rutaEliminarCliente = "/api/Master/CuestionarioPreAnalisisPersonaMoral/BorrarCliente";

export default {
  name: "CuestionarioPreAnalisisPersonaMoral",
  components: {
    TituloSeccion,
    VueAutonumeric
  },
  mixins: [mixinSolicitudInscripcion],
  data() {
    return {
      //opciones
      opcionesRadio : [
        {
          text: "Si",
          value: true
        },
        {
          text: "No",
          value: false
        }
      ],
      //Propiedades del autonumeric
      opcionesAutoNumeric : {
        digitGroupSeparator: ',',
        decimalCharacter: '.',
        decimalCharacterAlternative: '.',
        currencySymbol: '$',
        currencySymbolPlacement: 'p',
        roundingMethod: 'U',
        minimumValue: '0',
        maximumValue: '15000000'
      },
      seccionActual: 1,
      formularioValidado1: false,
      formularioValidado2: false,
      formularioValidado3: false,
      formularioValidado4: false,
      formularioValidado5: false,
      tipoUsuario: null,
      ProspectoId: null,
      catalogos: {
      giros: [],
      puestos: [],
      regimenesFiscales: []
      },
      DatosCuestionario: {
        solicitudId: null,
        giroEmpresa: null,
        aniosOperacion: null,
        participacionGeografica: null,
        ventasEfectivo: 0,
        ventasContado: 0,
        ventasCredito: 0,
        exportacion: 0,
        gobierno: 0,
        interCompania: 0,
        ventasNoContabilizadas: 0,
        ingresoExtraSocio: null,
        detalleIngresoExtraSocio:null,
        sociosTienenSaldosVencidosBuro: false,
        sociosTienenAntecedentesBuro: false,
        montoSolicitado: null,
        destinoRecurso: null,
        usoInmueble: null,
        completado: null
      },
      Clientes: [],
      FormClientes: [
        {
          clienteCuestionarioId:0,
          cliente: null,
          producto: null,
          porcentajeVenta: null
        }
      ],
      soloLectura: false
    };
  },
  async mounted() {
    this.DatosCuestionario.solicitudId = this.$store.getters.solicitudMoralId;
    this.ProspectoId = this.$store.getters.prospectoId;
    if(this.ProspectoId != null) {
      await this.ObtenerCuestionario();
    }
    this.tipoUsuario = this.$store.getters.tipoUsuario;
    this.VerificarSoloLectura();
    await this.CargarPuestos(false);
    await this.CargarGiros(false);
    await this.CargarRegimenesFiscales(false, true);

    if (this.tipoUsuario != 3) {
        this.seccionActual = 1;
       }

     if(this.etapaProspecto > 4)
     {this.soloLectura = true;}

     if(this.etapaProspecto > 4)
     {
      this.seccionActual = 1;
     }


  },
  computed: {
    camposVaciosFormCliente: function () {
      let llaves = Object.keys(this.FormClientes[this.FormClientes.length -1]);
      let vacios = 0;
      llaves.forEach(llave => {
        if(llave != "clienteCuestionarioId"){
          if(this.FormClientes[this.FormClientes.length -1][llave] == null || this.FormClientes[this.FormClientes.length -1][llave] == "" || this.FormClientes[this.FormClientes.length -1][llave] == 0 ){
            vacios++;
          }
        }
      });
      return vacios > 0 ? true : false;
    }
  },
  methods: {
    ValidaFormSiguiente(){
      let formularioValidado = false;
      switch (this.seccionActual) {
        case 1:
          this.formularioValidado1 = true;
          formularioValidado = this.$refs.formularioUno.checkValidity();
          break;
        case 4:
          this.formularioValidado4 = true;
          formularioValidado = this.$refs.formularioCuatro.checkValidity();
          break;
        case 5:
          this.formularioValidado5 = true;
          formularioValidado = this.$refs.formularioCinco.checkValidity();
          break;
      }
      if(formularioValidado) {
        if(this.seccionActual != 3){
          this.seccionActual++;
        }
      }

    },
    SeccionSiguiente() {
      switch (this.seccionActual) {
        case 1:
          this.$refs.submitUno.click();
          break;
        case 2:
          if(this.FormClientes.length > 0) {
            if(this.camposVaciosFormCliente == false) {
              this.seccionActual++;
            } else {
              this.AlertaEmbajadores("Por favor rellene todos los campos marcados con un *", true);
             }
          }
          break;
        case 3:
          if(this.SumaPorcentajeDeVentasEsValido())
            this.seccionActual++;
          else
            this.AlertaEmbajadores("El porcentaje total de ventas registradas de sumar 100%", true);
          break;
        case 4:
          this.$refs.submitCuatro.click();
          break;
        case 5:
          this.$refs.submitCinco.click();
          break;
      }
    },
    SeccionAnterior() {
      if(this.seccionActual != 1) {
        this.seccionActual -= 1;
      }
    },
    ActivarEnvioCuestionario() {
      this.$refs.enviaCuestionario.click();
    },
    ObtenerClientes(cuestionarioId) {

      const cuestionario = {
        params:{
          cuestionarioId: cuestionarioId
        }
      };
      axios.get(rutaObtenerClientes, cuestionario)
        .then(resp => {
          if (resp.data.estado === 0) {
            let arregloClientes = resp.data.data;
            if (arregloClientes.length > 0) {
              this.FormClientes = [];
              for (var item of arregloClientes) {
                let cliente = {
                  clienteCuestionarioId: item.clienteCuestionarioId,
                  cuestionarioPreAnalisisPersonaMoralId: item.cuestionarioPreAnalisisPersonaMoralId,
                  cliente: item.cliente,
                  producto: item.producto,
                  porcentajeVenta: item.porcentajeVenta * 100
                };
                this.FormClientes.push(cliente);
              }
            }
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    ObtenerCuestionario() {
      const prospecto = {
        params:{
          prospectoId: this.ProspectoId
        }
      };
      axios.get(rutaObtenerCuestionario, prospecto)
      .then((resp) => {
        if (resp.data.estado === 0) {
          if(resp.data.data != null) {
            this.DatosCuestionario.solicitudId = resp.data.data.solicitudId;
            this.DatosCuestionario.giroEmpresaId = resp.data.data.giroEmpresaId;
            this.DatosCuestionario.giroEmpresa = resp.data.data.giroEmpresa;
            this.DatosCuestionario.aniosOperacion = resp.data.data.aniosOperacion;
            this.DatosCuestionario.participacionGeografica = resp.data.data.participacionGeografica;
            this.DatosCuestionario.ventasEfectivo = resp.data.data.ventasEfectivo * 100;
            this.DatosCuestionario.ventasContado = resp.data.data.ventasContado * 100;
            this.DatosCuestionario.ventasCredito = resp.data.data.ventasCredito * 100;
            this.DatosCuestionario.exportacion = resp.data.data.exportacion * 100;
            this.DatosCuestionario.gobierno = resp.data.data.gobierno * 100;
            this.DatosCuestionario.interCompania = resp.data.data.interCompania * 100;
            this.DatosCuestionario.ventasNoContabilizadas = resp.data.data.ventasNoContabilizadas * 100;
            this.DatosCuestionario.ingresoExtraSocio = resp.data.data.ingresoExtraSocio;
            this.DatosCuestionario.detalleIngresoExtraSocio = resp.data.data.detalleIngresoExtraSocio;
            this.DatosCuestionario.sociosTienenSaldosVencidosBuro = resp.data.data.sociosTienenSaldosVencidosBuro;
            this.DatosCuestionario.sociosTienenAntecedentesBuro = resp.data.data.sociosTienenAntecedentesBuro;
            this.DatosCuestionario.detalleProblemaSocio = resp.data.data.detalleProblemaSocio;
            this.DatosCuestionario.montoSolicitado = resp.data.data.montoSolicitado;
            this.DatosCuestionario.destinoRecurso = resp.data.data.destinoRecurso;
            this.DatosCuestionario.usoInmueble = resp.data.data.usoInmueble;
            this.ObtenerClientes(resp.data.data.cuestionarioPreAnalisisPersonaMoralId);
          }
       } else if (resp.data.estado === 1) {
            this.AlertaEmbajadores(resp.data.mensaje, true);
        }
        }).catch((e) => {
            this.ManejarExcepcion(e);
        })
    },
    SumaPorcentajeDeVentasEsValido() {
      let arregloPorcentajes = [];
      let llaves = Object.keys(this.DatosCuestionario).slice(4,11);
      llaves.forEach(llave => arregloPorcentajes.push(this.DatosCuestionario[llave]));
      let suma = arregloPorcentajes.reduce((acc, cantidad) => acc + cantidad,0);
      return suma == 100 ? true : false;
    },
    GuardarCuestionario(){
      this.DatosCuestionario.completado = true;
      axios.post(rutaGuardarCuestionario, this.DatosCuestionario)
        .then(response => {
          if (response.data.estado === 0) {
            let cuestionarioPreAnalisisPersonaMoralId = response.data.data;
            this.GuardarCliente(cuestionarioPreAnalisisPersonaMoralId);
            this.AlertaEmbajadores("El cuestionario de preanálisis ha sido guardado correctamente.", true);

            if(this.$route.params.vieneDeAdministracion != undefined){
              this.$router.push({name: "IntegracionExpedienteMoral", params: { prospectoId: this.ProspectoId, vieneDeAdministracion: true }});
            } else {
              if(this.tipoUsuario == 6 || this.tipoUsuario == 8 || this.tipoUsuario == 9 || this.tipoUsuario == 10) {//Gerente o Master Operativo
                this.$router.push({name: "IntegracionExpedienteMoral"});
              } 
              else if(this.tipoUsuario == 4)//Preautorizador
                {
                  if(this.etapaProspecto == 5){
                  this.$router.push({name: "PreAutorizacion"});
                } 
                 else {
                  this.$router.push({name: "IntegracionExpedienteMoral"});
                }
                }
                else {
                  this.$router.push({name: "IntegracionExpedienteMoral"});
                }
            }
            //this.$router.push("/SolicitudEnviada");
          } else if (response.data.estado === 1) {
            this.AlertaEmbajadores(response.data.mensaje, false);
          }
        })
        .catch(e => {
          this.ManejarExcepcion(e);
        });
    },
    CamposActualesClientesVacios(index) {
      let llaves = Object.keys(this.FormClientes[index]);
      let vacios = 0;
      llaves.forEach(llave => {
        if (llave != "clienteCuestionarioId") {
          if (
            this.FormClientes[index][llave] == "" ||
            this.FormClientes[index][llave] == null ||
            this.FormClientes[index][llave] == 0
          ) {
            vacios++;
          }
        }
      });
      return vacios > 0 ? true : false;
    },
    GuardarCliente(cuestionarioPreAnalisisPersonaMoralId) {
      for (var cliente of this.FormClientes) {
        if (
          this.CamposActualesClientesVacios(
            this.FormClientes.indexOf(cliente)
          ) == false
        ) {
          //Se convierten a int los campos numéricos
          cliente.cuestionarioPreAnalisisPersonaMoralId = cuestionarioPreAnalisisPersonaMoralId;
          //Se ejecuta la petición POST para cada beneficiario en el arreglo
          axios
            .post(rutaGuardarClienteCuestionario, cliente)
            .then(response => {
              if (response.data.estado === 1) {
                this.AlertaEmbajadores(response.data.mensaje, true);
              }
            })
            .catch(e => {
              this.ManejarExcepcion(e);
            });
        }
      }
    },
    AgregarCliente() {
      if (this.camposVaciosFormCliente == false) {
        this.FormClientes.push({
          clienteCuestionarioId: 0,
          cliente: null,
          producto: null,
          porcentajeVenta: null
        });
      } else {
        this.AlertaEmbajadores("Por favor llene todos los campos marcados con un *.", true);
      }
    },
    EliminarCliente(cliente)  {
      if (this.tipoUsuario == 4 || this.tipoUsuario == 6 || this.tipoUsuario == 9)
        this.AlertaEmbajadores("No se pueden eliminar clientes en el modo solo lectura.", true);
      else
      {
        if(cliente.clienteCuestionarioId != 0) {
          axios
            .delete(rutaEliminarCliente + "?clienteId=" + cliente.clienteCuestionarioId)
            .then(resp => {
               if (resp.data.estado === 1) {
                this.AlertaEmbajadores(resp.data.mensaje, true);
              }
            })
            .catch(e => {
              this.ManejarExcepcion(e);
            });
            if (this.FormClientes.indexOf(cliente) > -1) {
              this.FormClientes.splice(this.FormClientes.indexOf(cliente), 1);
            }
        } else {
          if (this.FormClientes.indexOf(cliente) > -1) {
            this.FormClientes.splice(this.FormClientes.indexOf(cliente), 1);
          }
        }
      }
    }
  },
  watch : {

  }
};
</script>
<style scoped lang="scss">
@import "../../../../../assets/estilos/estilosgenerales.scss";
.principal-cuestionario {
  flex-grow: 1;
}
.texto-checkbox {
  text-align: initial;
  font-size: 16px;
  float: left;
  font-family: $poppins;
}
.form-container {
  width: 70%;
}
.pregunta {
  color: $color-primario;
  font-weight: 700;
}
@media (max-width: 512px) {
  .form-container {
    width: 90%;
  }
  .texto-checkbox {
    font-size: 14px;
    float: left;
    font-family: $poppins;
  }
}
</style>
